export interface CountryLanguage {
    readonly language: string,
    readonly country: string
}

export const countryLanguageResource = [
    {
        language: '', country: ''
    },
    {
        language: '', country: 'DE'
    },
    {
        language: 'de', country: 'DE'
    },
    {
        language: 'en', country: 'DE'
    },
    {
        language: 'es', country: 'DE'
    },
    {
        language: 'fr', country: 'DE'
    },
    {
        language: 'it', country: 'DE'
    },
    {
        language: 'pl', country: 'DE'
    },
    {
        language: 'nl', country: 'DE'
    },
    {
        language: 'pt', country: 'DE'
    },
    {
        language: 'hi', country: 'DE'
    },
    {
        language: 'zh', country: 'DE'
    },
    {
        language: 'ja', country: 'DE'
    },
    {
        language: 'ko', country: 'DE'
    },
    {
        language: '', country: 'US'
    },
    {
        language: 'de', country: 'US'
    },
    {
        language: 'en', country: 'US'
    },
    {
        language: 'es', country: 'US'
    },
    {
        language: 'fr', country: 'US'
    },
    {
        language: 'it', country: 'US'
    },
    {
        language: 'pl', country: 'US'
    },
    {
        language: 'nl', country: 'US'
    },
    {
        language: 'pt', country: 'US'
    },
    {
        language: 'hi', country: 'US'
    },
    {
        language: 'zh', country: 'US'
    },
    {
        language: 'ja', country: 'US'
    },
    {
        language: 'ko', country: 'US'
    },
    {
        language: '', country: 'PL'
    },
    {
        language: 'de', country: 'PL'
    },
    {
        language: 'en', country: 'PL'
    },
    {
        language: 'es', country: 'PL'
    },
    {
        language: 'fr', country: 'PL'
    },
    {
        language: 'it', country: 'PL'
    },
    {
        language: 'pl', country: 'PL'
    },
    {
        language: 'nl', country: 'PL'
    },
    {
        language: 'pt', country: 'PL'
    },
    {
        language: 'hi', country: 'PL'
    },
    {
        language: 'zh', country: 'PL'
    },
    {
        language: 'ja', country: 'PL'
    },
    {
        language: 'ko', country: 'PL'
    },
    {
        language: '', country: 'AT'
    },
    {
        language: 'de', country: 'AT'
    },
    {
        language: 'en', country: 'AT'
    },
    {
        language: 'es', country: 'AT'
    },
    {
        language: 'fr', country: 'AT'
    },
    {
        language: 'it', country: 'AT'
    },
    {
        language: 'pl', country: 'AT'
    },
    {
        language: 'nl', country: 'AT'
    },
    {
        language: 'pt', country: 'AT'
    },
    {
        language: 'hi', country: 'AT'
    },
    {
        language: 'zh', country: 'AT'
    },
    {
        language: 'ja', country: 'AT'
    },
    {
        language: 'ko', country: 'AT'
    },
    {
        language: '', country: 'IND'
    },
    {
        language: 'de', country: 'IND'
    },
    {
        language: 'en', country: 'IND'
    },
    {
        language: 'es', country: 'IND'
    },
    {
        language: 'fr', country: 'IND'
    },
    {
        language: 'it', country: 'IND'
    },
    {
        language: 'pl', country: 'IND'
    },
    {
        language: 'nl', country: 'IND'
    },
    {
        language: 'pt', country: 'IND'
    },
    {
        language: 'hi', country: 'IND'
    },
    {
        language: 'zh', country: 'IND'
    },
    {
        language: 'ja', country: 'IND'
    },
    {
        language: 'ko', country: 'IND'
    },
    {
        language: '', country: 'WW'
    },
    {
        language: 'de', country: 'WW'
    },
    {
        language: 'en', country: 'WW'
    },
    {
        language: 'es', country: 'WW'
    },
    {
        language: 'fr', country: 'WW'
    },
    {
        language: 'it', country: 'WW'
    },
    {
        language: 'pl', country: 'WW'
    },
    {
        language: 'nl', country: 'WW'
    },
    {
        language: 'pt', country: 'WW'
    },
    {
        language: 'hi', country: 'WW'
    },
    {
        language: 'zh', country: 'WW'
    },
    {
        language: 'ja', country: 'WW'
    },
    {
        language: 'ko', country: 'WW'
    },
    {
        language: '', country: 'XC'
    },
    {
        language: 'de', country: 'XC'
    },
    {
        language: 'en', country: 'XC'
    },
    {
        language: 'es', country: 'XC'
    },
    {
        language: 'fr', country: 'XC'
    },
    {
        language: 'it', country: 'XC'
    },
    {
        language: 'pl', country: 'XC'
    },
    {
        language: 'nl', country: 'XC'
    },
    {
        language: 'pt', country: 'XC'
    },
    {
        language: 'hi', country: 'XC'
    },
    {
        language: 'zh', country: 'XC'
    },
    {
        language: 'ja', country: 'XC'
    },
    {
        language: 'ko', country: 'XC'
    }
];
